import cc from "classcat"
import useTranslations from "hooks/useTranslations"
import ContentPageContainer from "components/molecules/common/ContentPageContainer"
import UnIcon3 from "images/somebuddy/un-icon-3.svg"
import UnIcon5 from "images/somebuddy/un-icon-5.svg"
import UnIcon16 from "images/somebuddy/un-icon-16.svg"

const Item = ({ item }) => {
  return (
    <div className="flex flex-col items-start py-10 sm:flex-row sm:space-x-8">
      <item.icon
        className={cc(["-mt-2 w-48 shrink-0 sm:mx-auto", item.color])}
      />
      <div className="flex flex-col items-start sm:space-y-6">
        <h2 className="mb-0 grow text-left text-2xl text-zinc-800">
          {item.name}
        </h2>
        <p className="mb-0 grow whitespace-pre-line text-left font-body text-base text-zinc-800">
          {item.description}
        </p>
      </div>
    </div>
  )
}

export default function SustainableDevelopmentGoals() {
  const {
    solutionsTitle,
    solutions1Name,
    solutions1Description,
    solutions2Name,
    solutions2Description,
    solutions3Name,
    solutions3Description,
  } = useTranslations()

  const list = [
    {
      name: solutions1Name,
      description: solutions1Description,
      color: "text-[#279C81]",
      icon: UnIcon3,
    },
    {
      name: solutions2Name,
      description: solutions2Description,
      color: "text-[#678BCB]",
      icon: UnIcon16,
    },
    {
      name: solutions3Name,
      description: solutions3Description,
      color: "text-[#F46982]",
      icon: UnIcon5,
    },
  ]

  return (
    <ContentPageContainer title={solutionsTitle}>
      {list.map((item) => (
        <Item id={item.name} item={item} />
      ))}
    </ContentPageContainer>
  )
}
